import { SalesforceSyncTypes } from 'module/api/integrations/salesforce/types';
import { SalesforceFieldMappingLocalData } from 'module/api/integrations/salesforce/types';
import {
  CustomOption,
  SingleValueProps,
} from 'module/ui/components/atoms/select';
import { faArrowRightArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import { syncOptions } from '../use-field-mapping-actions';

const GetSyncIcon = ({ value }: { value: SalesforceSyncTypes }) => {
  switch (value) {
    case SalesforceSyncTypes.SyncExternalToNative: {
      return (
        <FontAwesomeIcon
          icon={faArrowRight}
          style={{ color: 'var(--icon-secondary)' }}
        />
      );
    }

    case SalesforceSyncTypes.SyncTwoWay: {
      return (
        <FontAwesomeIcon
          icon={faArrowRightArrowLeft}
          style={{ color: 'var(--icon-secondary)' }}
        />
      );
    }

    case SalesforceSyncTypes.SyncNativeToExternal: {
      return (
        <FontAwesomeIcon
          icon={faArrowLeft}
          style={{ color: 'var(--icon-secondary)' }}
        />
      );
    }

    default: {
      return null;
    }
  }
};

export const SyncOptionLabel = (data: CustomOption) => {
  const { value, label } = data;

  return (
    <Space align="center">
      <GetSyncIcon value={value as SalesforceSyncTypes} />
      <FormattedMessage
        id={`settings.integrations.sf.resource_mappings.sync.${label.toLowerCase()}`}
      />
    </Space>
  );
};

export const SelectedSyncValue = ({ data }: SingleValueProps) => (
  <GetSyncIcon value={data.value.toString() as SalesforceSyncTypes} />
);

export const SyncSelectStyles = {
  control: (provided) => {
    return {
      ...provided,
      boxShadow: 'none',
      border: 'none',
      div: {
        display: 'flex',
        alignItems: 'center',
      },
    };
  },
  menu: (provided) => ({
    ...provided,
    minWidth: '200px',
    width: 'auto',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    '.ant-space-item': {
      display: 'flex',
    },
  }),
};

export const getValidSyncOptions = (
  fieldMap: SalesforceFieldMappingLocalData,
) => {
  // ✅ If allowedSyncTypes is provided by backend, use it to filter options
  if (fieldMap.allowedSyncTypes && fieldMap.allowedSyncTypes.length > 0) {
    return syncOptions.filter((option) =>
      fieldMap.allowedSyncTypes?.includes(option.value),
    );
  }

  // Fallback to old logic when allowedSyncTypes is not available
  const isSyncBothWays =
    fieldMap.rocketlaneField?.extra && fieldMap.salesforceField?.extra;
  const isSyncToExternal =
    fieldMap.rocketlaneField?.extra?.isEditable === false;
  const isSyncToNative = fieldMap.salesforceField?.extra === false;

  switch (true) {
    case isSyncBothWays: {
      return syncOptions;
    }
    case isSyncToExternal: {
      return [
        {
          label: SalesforceSyncTypes.SyncNativeToExternal,
          value: SalesforceSyncTypes.SyncNativeToExternal,
        },
      ];
    }
    case isSyncToNative: {
      return [
        {
          label: SalesforceSyncTypes.SyncExternalToNative,
          value: SalesforceSyncTypes.SyncExternalToNative,
        },
      ];
    }
    default: {
      return syncOptions;
    }
  }
};
